export interface IPayoutRatesModel {
  id: string;
  coachId: string;
  clubId: string;
  paymentTypeAlias: PaymentTypeAlias;
  salary: string;
  personalClassRate: string;
  fixedClassRate: string;
  personInGroupRate: string;
  subscriptionPercentRate: number;
  forUnlimitedRate: number;
  effectiveSinceDate: string;
  isEnableMode: boolean;
  universalRate: string; 
  coursesIds: string; 
}

export interface IClassRateParam {
  coachId: string;
  classIds: string[];
}

export interface ClassRate {
  id: string;
  coachId: string;
  clubId: string;
  salary: number;
  personalClassRate: number;
  fixedClassRate: number;
  personInGroupRate: number;
  subscriptionPercentRate: number;
  forUnlimitedRate: number;
  effectiveSinceDate: Date;
}

export enum PaymentTypeAlias {
  class = 'class',
  personInGroup = 'personInGroup',
  subscription = 'subscription', //Больше не используется. Оставил для того, чтобы в старых отчетах он не пропал. 
  pctWithMissed = 'pctWithMissed',
  pctWithoutMissed = 'pctWithoutMissed', 
  progressiveRate = 'progressiveRate',
  withoutRate = 'withoutRate'

}

export const PaymentTypeAliasDisplayName: { [ key in PaymentTypeAlias | 'salary' | 'other' ]: string } = {
  class: 'Ставка за занятие',
  personInGroup: 'Ставка за человека',
  salary: 'Оклад',
  other: 'Прочее',
  subscription: 'За абонемент',
  pctWithMissed: '% от занятия, включая пропуски',
  pctWithoutMissed: '% от занятия без пропусков',
  progressiveRate: 'Прогрессивная ставка',
  withoutRate: 'withoutRate'

};
